export const getVideoInfo = (url: string) => {
  // Regular expressions to match Vimeo and YouTube URLs
  const vimeoRegex: any =
    /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:\w+\/)?|album\/(?:\d+\/)?|video\/|)(\d+)/i;
  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&].*)?/i;


  // Match Vimeo URL
  const vimeoMatch = url?.match(vimeoRegex);
  if (vimeoMatch) {
    return {
      videoId: vimeoMatch?.[1],
    };
  }

  // Match YouTube URL
  const youtubeMatch = url?.match(youtubeRegex);
  if (youtubeMatch) {
    return {
      videoId: youtubeMatch?.[1],
    };
  }

  // If the URL is neither Vimeo nor YouTube, return it as is
  return {
    videoId: url,
  };
};






